import styled from 'styled-components'

/**
 * Page
 */

export const makeMainPage = ({ theme }) => {
  return `@media (min-width: ${theme.screen.lgMin}){
            margin: 24px 0;
            position: relative;
            z-index: 10;
          }`
}

/**
 * Custom Col
 */

export const makeScrollCol = ({ theme }) => {
  return `@media (min-width: ${theme.screen.lgMin}){
            height: calc(100vh - 157px);
            overflow: auto;
            position: sticky;
            top: 135px;
          }
          
          @media (min-width: ${theme.screen.xlMin}){
            top: 155px;
          }`
}

export const AdListadoTopBanner = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 140px;
`

export const AdListadoLeaderboard = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 140px;
`

export const AdListadoMobileFooter = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 125px;
`

export const AdLoader = styled.div`
  position: absolute;
  z-index: -1;
  top: 50%;
  left: 50%;
  transform: translate(-50%);
`

export const AdListadoCard = styled.div`
  cursor: pointer;
  position: relative;
  margin-top: 16px;
  box-shadow: 0px 0px 0px rgba(0, 0, 0, 0.12);
  transition: all 0.2s ease-in-out;
  min-height: 120px;

  &:hover,
  &:focus {
    box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.12);
  }
`

export const AdListadoGoogleConatiner = styled.div`
  min-height: 90px;
  margin-bottom: 12px;
`
